// Shared react-query retry policy: never retry a 4xx, always cap the attempts.

const MAX_QUERY_RETRIES = 3

const getErrorStatus = (error: unknown): number | undefined => {
  if (typeof error !== 'object' || error === null || !('status' in error)) {
    return undefined
  }

  const { status } = error as { status: unknown }

  return typeof status === 'number' ? status : undefined
}

// `true` for 4xx — an answer, not a transient failure.
export const isClientError = (error: unknown): boolean => {
  const status = getErrorStatus(error)

  return status !== undefined && status >= 400 && status < 500
}

// Default `retry` predicate: retry transient failures only, up to MAX_QUERY_RETRIES.
export const shouldRetryQuery = (failureCount: number, error: unknown): boolean =>
  failureCount < MAX_QUERY_RETRIES && !isClientError(error)
